export default "__VITE_ASSET__BWqlPIh1__"